// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"ba65855b","884":"0f12db44"}[chunkId] + ".chunk.js";
};